const Surveys = () => import('@/pages/profile/surveys/Surveys.vue')
const InterviewsSurveysPersonalInfoPage = () => import('@/pages/profile/surveys/PersonalInfoPage.vue')
const ActualAnalysis = () => import('@/pages/profile/surveys/ActualAnalysis.vue')
const PersonalCompetencies = () => import('@/pages/profile/surveys/PersonalCompetencies.vue')
const TargetAnalysis = () => import('@/pages/profile/surveys/TargetAnalysis.vue')
const InterviewsSurveysProfessionalProfilePage = () => import('@/pages/profile/surveys/ProfessionalProfilePage.vue')

export default {
  path: 'interviews/surveys',
  name: 'InterviewsSurveysLayout',
  component: Surveys,
  meta: {
    layout: 'default',
    requiresAuth: true
  },
  children: [
    {
      path: 'personal_info',
      name: 'interviewsSurveysPersonalInfoPage',
      component: InterviewsSurveysPersonalInfoPage,
      meta: {
        layout: 'default',
        requiresAuth: true,
        isEdit: true
      }
    },
    {
      path: 'professional_profile',
      name: 'interviewsSurveysProfessionalProfilePage',
      component: InterviewsSurveysProfessionalProfilePage,
      meta: {
        layout: 'default',
        requiresAuth: true,
        isEdit: true
      }
    },
    {
      path: 'actual_analysis',
      name: 'ProfileInterviewActualAnalysis',
      component: ActualAnalysis,
      meta: {
        isEdit: true,
        layout: 'default',
        requiresAuth: true,
        tab: 'interview'
      }
    },
    {
      path: 'personal_competencies',
      name: 'ProfileInterviewPersonalCompetencies',
      component: PersonalCompetencies,
      meta: {
        isEdit: true,
        layout: 'default',
        requiresAuth: true,
        tab: 'interview'
      }
    },
    {
      path: 'target_analysis',
      name: 'ProfileTargetAnalysis',
      component: TargetAnalysis,
      meta: {
        isEdit: true,
        layout: 'default',
        requiresAuth: true,
        tab: 'interview'
      }
    }
  ]
}
